"use client";

import { useField } from "formik";
import { cn } from "@/lib/utils";
import type { InputHTMLAttributes } from "react";

export interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {
	label: string;
	name: string;
	helperText?: string;
}

export function InputField({
	label,
	className,
	helperText,
	...props
}: InputFieldProps) {
	const [field, meta] = useField(props.name);
	const hasError = Boolean(meta.touched && meta.error);

	return (
		<label className="form-control w-full">
			<div className="label">
				<span className="label-text font-semibold">{label}</span>
			</div>
			<input
				{...field}
				{...props}
				className={cn(
					"input input-bordered border w-full",
					className,
					hasError && "input-error"
				)}
			/>
			<div className="label">
				{hasError ? (
					<span className="label-text-alt text-error">
						{meta.error}
					</span>
				) : helperText ? (
					<span className="label-text-alt text-muted-foreground">
						{helperText}
					</span>
				) : null}
			</div>
		</label>
	);
}
